import React, { ReactNode } from "react";
import s from "./InnerContentWrapper.less";
import clsx from "clsx";

interface IContentWrapperProps {
  className?: string;
  children: ReactNode;
}

const InnerContentWrapper = ({ children, className }: IContentWrapperProps) => {
  return <div className={clsx(s.wrapper, className)}>{children}</div>;
};

export default InnerContentWrapper;
